import { useMemo, useState } from "react";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import Formulario from "../../Componentes/Utils/Formulario";
import FormComp from "../../Componentes/FormComp";
import useApi from "../../hooks/useApi";

export default function ModalNovoTipoAtivo({ onClose, onCreated }) {
  const api = useApi();
  const [saving, setSaving] = useState(false);
  const [descricao, setDescricao] = useState("");

  const canSubmit = useMemo(() => Boolean(descricao.trim()), [descricao]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setSaving(true);

      // Rota fictícia (backend você vai criar)
      await api.post("/Painel/API/InventarioTI/tipo_ativo/create.php", {
        descricao: descricao.trim().toUpperCase(),
      });

      onClose?.();
      onCreated?.();
    } catch (err) {
      console.error(err);
      alert("Erro ao criar tipo de ativo.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Overlay state={true}>
      <Modal header close={onClose} size="sm">
        <Formulario onSubmit={handleSubmit}>
          <FormComp
            title="DESCRIÇÃO DO TIPO"
            type="text"
            placeholder="EX: NOTEBOOK"
            valor={descricao}
            name="descricao"
            changeFunc={(e) => setDescricao(e.target.value)}
            required
          />
          <FormComp
            type="submit"
            valor={saving ? "SALVANDO..." : "SALVAR"}
            disabled={saving || !canSubmit}
          />
        </Formulario>
      </Modal>
    </Overlay>
  );
}

